<template>
  <div>
    <Label :label="label" />
    <div class="flex gap-5">
      <slot />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  props: {
    label: String,
  },
})
</script>
